import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import { RouteType } from '../../types';
import { translate } from '../../utils';
import { routePaths } from '../../routePaths';
import { ExpensesBreakdown } from '../../modules';
import { VenueType } from '../../generated/graphql';
import ReportsPage from './ReportsPage';
import CategoryStatistics from './CategoryStatistics';
import ProductStatistics from './ProductStatistics';
import TableStatistics from './TableStatistics';

const Reports: RouteType = {
    exact: true,
    path: routePaths.reports,
    showInSideBar: true,
    icon: AssessmentOutlinedIcon,
    title: translate('Reports'),
    component: ReportsPage,
    childrenRoutes: [
        {
            exact: true,
            showInSideBar: true,
            component: ExpensesBreakdown,
            path: routePaths.reportsExpenses,
            title: translate('Costs (COGS)')
        },
        {
            exact: true,
            showInSideBar: true,
            title: translate('Product Sales'),
            path: routePaths.reportsProducts,
            component: ProductStatistics,
        },
        {
            exact: true,
            showInSideBar: true,
            title: translate('Category Sales'),
            path: routePaths.reportsCategories,
            component: CategoryStatistics,
        },
        {
            exact: true,
            showInSideBar: true,
            allowedVenueTypes: [VenueType.Restaurant],
            title: translate('Table Sales'),
            path: routePaths.reportsTables,
            component: TableStatistics,
        }
    ],
};

export default Reports;